import { render, staticRenderFns } from "./inventory-tab-partial.vue?vue&type=template&id=5a1d49fe"
import script from "./inventory-tab-partial.vue?vue&type=script&lang=js"
export * from "./inventory-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports